import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=013a4a88&"
import script from "./logins.vue?vue&type=script&lang=js&"
export * from "./logins.vue?vue&type=script&lang=js&"
import style0 from "./logins.vue?vue&type=style&index=0&id=013a4a88&prod&lang=less&"
import style1 from "./logins.vue?vue&type=style&index=1&id=013a4a88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports